import { Grid } from '@backstage/ui';
import { EntityLayout } from './entity-layout';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../core/i18n';
import layoutStyles from './layouts.module.css';
import { EntityWarningContent, AboutCard, LinksCard, EntityGraphCard, HasSystemsCard } from '../components';

export const DomainEntityLayout = () => {
  const { t } = useTranslationRef(appTranslationRef);

  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title={t('entity.tabs.overview')}>
        <Grid.Root columns="12" gap="3" className={layoutStyles.gridStretch}>
          <EntityWarningContent />

          {/* Left column: business info */}
          <Grid.Item colSpan={{ xs: '12', md: '8' }}>
            <Grid.Root columns="1" gap="3" className={layoutStyles.gridStretch}>
              <Grid.Item colSpan="1">
                <AboutCard />
              </Grid.Item>
              <Grid.Item colSpan="1">
                <HasSystemsCard />
              </Grid.Item>
            </Grid.Root>
          </Grid.Item>

          {/* Right column: navigation & context */}
          <Grid.Item colSpan={{ xs: '12', md: '4' }}>
            <Grid.Root columns="1" gap="3" className={layoutStyles.gridStretch}>
              <Grid.Item colSpan="1">
                <LinksCard />
              </Grid.Item>
              <Grid.Item colSpan="1">
                <EntityGraphCard />
              </Grid.Item>
            </Grid.Root>
          </Grid.Item>
        </Grid.Root>
      </EntityLayout.Route>
    </EntityLayout>
  );
};
